import { render } from "./Specialities.vue?vue&type=template&id=e73071aa"
import script from "./Specialities.vue?vue&type=script&lang=js"
export * from "./Specialities.vue?vue&type=script&lang=js"

import exportComponent from "/srv/volumes/sshfs-rpi3ex/bilimcert/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__